import Constants from "common/constant";
import { IconViewed } from "features/user/assets";
import { ProjectEntity } from "features/creator/types";
import {
  CardBg,
  IconProjectCardFavoritedReverse,
  IconPublishCopiedOn,
  IconPublishCopiedOff,
} from "features/creator/assets";

interface ParentProjectCardProps {
  project: ProjectEntity;
  onClick: () => void;
}

export const ParentProjectCard = ({ project, onClick }: ParentProjectCardProps) => {
  return (
    <div
      className="flex-col-el flex-center gap-2 w-[168px] cursor-pointer shrink-0"
      onClick={onClick}
    >
      <div className="flex-col-center">
        {/* 公開状態アイコン */}
        <div className="flex-col-center w-[48px] h-[40px]">
          {project.published ? (
            <div className="flex-col-center w-[40px] h-[40px]">
              {project.enable_copied ? <IconPublishCopiedOn /> : <IconPublishCopiedOff />}
            </div>
          ) : (
            <img
              alt="unpublished"
              src={`${Constants.assetHost}/assets/images/publish_on.png`}
              className="w-[36px] h-[36px]"
            />
          )}
        </div>

        {/* カセットフレーム */}
        <div className="flex-col-center rounded-[16px] p-2">
          {/* CardBg SVGフレーム（背景） */}
          <div className="flex-col-el flex-center w-[168px] h-[186px] absolute -z-0">
            <CardBg />
          </div>

          {/* カセット本体 */}
          <div className="flex-col-center w-[144px] h-[178px] ml-4">
            {/* スイッチ画像 */}
            <div className="flex-col-el flex-center absolute w-[62px] h-[64px]">
              <img
                alt="switch"
                className="w-full h-full"
                src={`${Constants.assetHost}/assets/images/project_card_switch.png`}
              />
            </div>

            {/* カセット背景 + サムネイル */}
            <div className="flex-col-center w-full h-full">
              <img
                alt="app card"
                src={`${Constants.assetHost}/assets/images/app_card_user.png`}
                className="w-full h-full"
              />

              {/* サムネイル領域 */}
              <div className="flex-col-el flex-center absolute top-[39px] w-full px-[9px] h-[120px]">
                {project?.cover || project?.capture ? (
                  <div className="flex-col-center w-full h-full overflow-hidden bg-white">
                    <img
                      alt="サムネイル"
                      className="w-full h-full object-cover"
                      src={project?.cover ?? project?.capture}
                      onError={(e) => {
                        (e.target as HTMLImageElement).src =
                          `${Constants.assetHost}/assets/images/default_capture.png`;
                      }}
                    />
                  </div>
                ) : (
                  <div className="w-full h-full bg-white" />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* プロジェクト名（1行省略） */}
      <div className="flex-row-center w-full">
        <p className="text-body text-center text-body-ellipsis text-[24px] leading-6 text-textcolor-black w-full">
          {project.name}
        </p>
      </div>

      {/* 統計情報 */}
      <div className="flex-row-center w-full gap-3">
        {/* ビュー数 */}
        <div className="flex-row-el items-center gap-1">
          <div className="w-[24px] h-[24px]">
            <IconViewed className="w-full h-full" />
          </div>
          <span className="text-[18px] text-brown-100">{project.viewed}</span>
        </div>
        {/* いいね数 */}
        <div className="flex-row-el items-center gap-1">
          <div className="w-[24px] h-[24px]">
            <IconProjectCardFavoritedReverse className="w-full h-full" />
          </div>
          <span className="text-[18px] text-brown-100">{project.favorited}</span>
        </div>
      </div>
    </div>
  );
};
